import {useTranslation} from 'react-i18next';
import * as css from './TicketCardCarousel.css';
import CarouselChevron from '../../../assets/icons/CarouselChevron';

interface CarouselArrowsProps {
    count: number;
    activeIndex: number;
    onSelect: (index: number) => void;
}

function CarouselArrows({count, activeIndex, onSelect}: CarouselArrowsProps) {
    const {t} = useTranslation('eTicket');
    return (
        <>
            <css.navButton
                className="prev"
                data-cy="entrance-ticket-prev"
                aria-label={t('prev')}
                disabled={activeIndex === 0}
                onClick={() => onSelect(activeIndex - 1)}>
                <CarouselChevron fill="currentColor" />
            </css.navButton>
            <css.navButton
                className="next"
                data-cy="entrance-ticket-next"
                aria-label={t('next')}
                disabled={activeIndex === count - 1}
                onClick={() => onSelect(activeIndex + 1)}>
                <CarouselChevron fill="currentColor" />
            </css.navButton>
        </>
    );
}

export default CarouselArrows;
